
$(function () {

    let announcementSlider = {   
        speed: 7000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        centerPadding: '0px',
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 992,
                settings: 'unslick'
            },
        ]
    }
    let winAnnouncement = $(window);
    let sliderAnnouncement = $(".js-header-usp-slider");

    winAnnouncement.on("load resize", function () {  
        if (winAnnouncement.width() < 992) {
            sliderAnnouncement.not(".slick-initialized").slick(announcementSlider);
        } else if (sliderAnnouncement.hasClass("slick-initialized")) {
            sliderAnnouncement.slick("unslick");
        }
    });

    $('.eq-tab-content__right-slider').each(function(index) {

        $(this).addClass('js-tab-item' + (index + 1));

        $(this).slick({
            centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            lazyLoad: 'ondemand',
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow"><svg fill=none height=8 viewBox="0 0 35 8"width=35 xmlns=http://www.w3.org/2000/svg><path d="M0.646446 4.35355C0.451183 4.15829 0.451183 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM35 4.5H1V3.5H35V4.5Z" fill=#000 /></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg fill=none height=8 viewBox="0 0 35 8"width=35 xmlns=http://www.w3.org/2000/svg><path d="M34.3536 4.35355C34.5488 4.15829 34.5488 3.84171 34.3536 3.64645L31.1716 0.464466C30.9763 0.269204 30.6597 0.269204 30.4645 0.464466C30.2692 0.659728 30.2692 0.976311 30.4645 1.17157L33.2929 4L30.4645 6.82843C30.2692 7.02369 30.2692 7.34027 30.4645 7.53553C30.6597 7.7308 30.9763 7.7308 31.1716 7.53553L34.3536 4.35355ZM0 4.5H34V3.5H0V4.5Z" fill=#000 /></svg></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
        
    });
    
    $('.eq-tab-list ul li').on('click', function () {
        $('.eq-tab-list ul li').removeClass("tab-active");
        let target = $(this).attr('data-id');
        if(target){
            $(this).addClass("tab-active");
            if ($(window).width() >= 992) {
                $('html, body').animate({ scrollTop: $($(`#${target}`)).offset().top - 90 }, 300);
            }else{
                $('html, body').animate({ scrollTop: $($(`#${target}`)).offset().top - 115 }, 300);
            }
        }
        
    });

    $('.eq-faq__que').on("click", function() {
        let dropDown = $(this).closest('.eq-faq__item').find('.eq-faq__ans');

        $(this).closest('.eq-faq__accordion').find('.eq-faq__ans').not(dropDown).slideUp();

        if ($(this).parent(".eq-faq__item").hasClass('active')) {
            $(this).parent(".eq-faq__item").removeClass('active');
        } else {
            $(this).closest('.eq-faq__accordion').find('.eq-faq__item.active').removeClass('active');
            $(this).parent(".eq-faq__item").addClass('active');
        }

        dropDown.stop(false, true).slideToggle();

    });


});

document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".eq-tabs-sticky-wrapper ul li");
    const sections = document.querySelectorAll(".eq-tab-content");

    if (!tabs.length || !sections.length) {
        console.error("❌ Tabs or Sections not found!");
        return;
    }

    let lastActiveId = null;
    
    setTimeout(() => {
        
        const observerOptions = {
            root: null,
            rootMargin: '-130px 0px -92% 0px',
            threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
            let activeSection = null;
    
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    activeSection = entry.target;
                }
            });
    
            if (activeSection) {
                const id = activeSection.id;
    
                if (id !== lastActiveId) {
                    lastActiveId = id;
    
                    // Remove active class from all tabs
                    tabs.forEach((tab) => tab.classList.remove("tab-active"));
    
                    // Find and activate the corresponding tab
                    tabs.forEach((tab) => {
                        if (tab.getAttribute("data-id") === id) {
                            tab.classList.add("tab-active");
                        }
                    });
                }
            }
        }, observerOptions);

        sections.forEach((section) => observer.observe(section));

    }, 500);

});